// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteColumnOutlinedSvg from "@ant-design/icons-svg/es/asn/DeleteColumnOutlined";
import AntdIcon from '../components/AntdIcon';

var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteColumnOutlinedSvg
  }));
};

DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
export default React.forwardRef(DeleteColumnOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DeleteColumnOutlined.js
// module id = 917
// module chunks = 0